// หน้าที่เปิดอยู่ = อยู่ใน URL (28 ต.ค. 69 user: "ทุกครั้งที่ refresh ระบบจะกลับไปหน้าแรก อยากให้อยู่หน้าเดิม")
//   รีเฟรช / เปิดแท็บใหม่ / ส่งลิงก์ให้เพื่อน = เปิดตรงหน้านั้นเลย · ปุ่มย้อนกลับของเบราว์เซอร์ = กลับหน้าก่อนในแอพ
//
//   /                          วันนี้
//   /console/<รหัสตู้>          Console + ตู้ที่เลือก
//   /brands/<partner id>       แบรนด์ + แบรนด์ที่เลือก
//   /products?brand=&cat=&q=   สินค้า & HS + แบรนด์/หมวด/คำค้น (ไม่ระบุ = _none)
//   /screening/<hs>            คัดกรองก่อนสั่ง + พิกัดที่เปิดดู
//   /settings/<zone>           ตั้งค่า + หน้าย่อย (people · trash · rules · fta · audit)
//   /handbook · /analytics
//   /materials?focus=<id>      วัสดุจาก AI (ตรวจผลก่อนลงสินค้า) · focus = เปิดแถวนี้ให้เลย
//   /dossier/<consignment id>  ใบข้อมูลสินค้า
//   /permit/<classification id> เอกสารยื่นขอใบอนุญาต
//
//   ไปหน้าใหม่ (แท็บ / ใบข้อมูลสินค้า / ใบอนุญาต) = เพิ่มประวัติ (push)
//   เลือกของในหน้าเดิม (ตู้ / แบรนด์ / คำค้น) = แทนที่ (replace) — กดย้อนกลับจะได้ไม่ต้องไล่ผ่านทุกตู้ที่เคยคลิก
//
//   ⚠ เขียน URL ได้หลัง session โหลดเสร็จเท่านั้น — ลิงก์ "ลืมรหัสผ่าน" ส่ง token มาทาง #… ต้องให้ Supabase อ่านก่อน
//     (writeUrl ทิ้ง #… เสมอ — ดูเหตุผลที่ writeUrl)
//   ⚠ ไฟล์นี้ไม่เช็คสิทธิ์ — App ต้องเช็คเองว่าหน้าใน URL เปิดให้คนนี้ไหม (พิมพ์ /analytics เองได้)
//   ⚠ ทุกหน้าใน URL ต้องไม่ชนไฟล์จริงใน dist/ หรือ functions/ (/guide = คู่มือ · /api/* = Pages Functions)

export const TAB_IDS = ['today', 'console', 'brands', 'products', 'materials', 'screening', 'handbook', 'analytics', 'settings'];

// แบรนด์/หมวด "ไม่ระบุ" ในหน้าสินค้า (db.NO_BRAND = \0none · db.NO_CAT = " none") ใส่ลง URL ตรงๆ ไม่ได้
//   (ไม่ใช้ ~ — URLSearchParams เข้ารหัสเป็น %7E อ่านยาก)
const NONE = '_none';

const dec = (s) => { try { return decodeURIComponent(s); } catch { return s; } };
const enc = encodeURIComponent;

// noBrand / noCat = ค่า sentinel ของ data.js (ส่งเข้ามา ไม่ import ตรง — ไฟล์นี้จะได้ไม่ผูกกับ Supabase)
export function readRoute({ noBrand, noCat } = {}, loc = window.location) {
  const [head, arg] = loc.pathname.split('/').filter(Boolean).map(dec);
  if (head === 'dossier' && arg) return { tab: 'console', dossier: arg };
  if (head === 'permit' && arg) return { tab: 'products', permit: arg };
  const tab = TAB_IDS.includes(head) ? head : 'today';
  const r = { tab };
  if (tab === 'console' && arg) r.ship = arg;
  if (tab === 'brands' && arg) r.partner = arg;
  if (tab === 'screening' && arg) r.hs = arg;
  if (tab === 'settings' && arg) r.zone = arg;
  if (tab === 'products') {
    const sp = new URLSearchParams(loc.search);
    const b = sp.get('brand'), c = sp.get('cat');
    r.q = sp.get('q') ?? '';
    r.brand = b == null || b === '' ? null : b === NONE ? noBrand : b;
    r.cat = c == null || c === '' ? null : c === NONE ? noCat : c;
  }
  if (tab === 'materials') {
    const f = new URLSearchParams(loc.search).get('focus');
    if (f) r.focus = f;
  }
  return r;
}

export function routeUrl(r, { noBrand, noCat } = {}) {
  if (r.dossier) return `/dossier/${enc(r.dossier)}`;
  if (r.permit) return `/permit/${enc(r.permit)}`;
  const base = r.tab === 'today' || !TAB_IDS.includes(r.tab) ? '/' : `/${r.tab}`;
  if (r.tab === 'console' && r.ship) return `${base}/${enc(r.ship)}`;
  if (r.tab === 'brands' && r.partner) return `${base}/${enc(r.partner)}`;
  if (r.tab === 'screening' && r.hs) return `${base}/${enc(r.hs)}`;
  if (r.tab === 'settings' && r.zone) return `${base}/${enc(r.zone)}`;
  if (r.tab === 'products') {
    const sp = new URLSearchParams();
    if (r.brand != null) sp.set('brand', r.brand === noBrand ? NONE : r.brand);
    if (r.cat != null) sp.set('cat', r.cat === noCat ? NONE : r.cat);
    if (r.q) sp.set('q', r.q);
    const s = sp.toString();
    return s ? `${base}?${s}` : base;
  }
  // focus เป็น query ไม่ใช่ path — public/_headers ใส่ no-store ตาม path (/materials) ถ้าเพิ่ม path ต้องเพิ่มกฎตามทุกครั้ง
  if (r.tab === 'materials' && r.focus) return `${base}?focus=${enc(r.focus)}`;
  return base;
}

// เขียน URL · คืน false ถ้า URL เดิมอยู่แล้ว (ไม่ต้องทำอะไร)
//   ทิ้ง #… เสมอ — แอพไม่ใช้ hash เลย และ hash ที่ยังค้างหลัง Supabase อ่านแล้ว = ลิงก์ "ลืมรหัสผ่าน" ที่ใช้ไม่สำเร็จ
//     (#access_token=…&refresh_token=… ยังอยู่ครบ) ถ้าเก็บไว้ จะติดไปกับทุกลิงก์ที่คนก๊อปไปแปะในแชท
//     = คนรับเอาไปตั้งรหัสใหม่ของบัญชีนั้นได้ (บัญชีเดียวใช้ทุกแอพของบริษัท) — รีวิว 28 ต.ค. 69
//   history.state.ib = ลำดับหน้าในแอพ → มากกว่า 0 = มีหน้าก่อนหน้าที่เป็นของแอพนี้ (ปุ่ม "← กลับ" ใช้ history.back ได้)
//   Safari โยน SecurityError ถ้า replaceState ถี่เกิน 100 ครั้ง/30 วิ → กลืนไว้ (URL แค่ไม่อัปเดตรอบนั้น)
export function writeUrl(url, { push = false } = {}) {
  const now = window.location.pathname + window.location.search;
  if (url === now && !window.location.hash) return false;
  try {
    if (push && url !== now) window.history.pushState({ ib: (window.history.state?.ib ?? 0) + 1 }, '', url);
    else window.history.replaceState(window.history.state, '', url);
  } catch { /* ถี่เกิน — ข้าม */ }
  return url !== now;
}

// มีหน้าก่อนหน้าในแอพไหม (เปิดจากลิงก์ที่ส่งมา/แท็บใหม่ = ไม่มี → ปุ่ม "← กลับ" ต้องไปหน้าตั้งต้นเอง)
export const hasAppHistory = () => (window.history.state?.ib ?? 0) > 0;
